import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/Logo.png";
import styles from "./Footer.module.css";
import qLogo from "../../assets/q.png";
import {
  AiOutlineFacebook,
  AiOutlineLinkedin,
  AiOutlineMail,
  AiOutlineTwitter,
  AiOutlineYoutube,
} from "react-icons/ai";
const Footer = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <Row>
          <Col className="py-4 d-flex justify-content-start  align-items-md-start align-items-center flex-column">
            <img src={logo} alt="" className={styles.logo} />
          </Col>
        </Row>
        <Row className="pb-5">
          <Col
            md={4}
            className="d-flex justify-content-start  align-items-md-start align-items-center flex-column"
          >
            <span className={`${styles.heading} d-block text-white fw-bold`}>
              Services
            </span>
            <div className="d-flex justify-content-start  align-items-md-start align-items-center flex-column pt-3">
              <Link to="/services/3D-Printing" className={styles.link}>
                3D Printing
              </Link>
              <Link to="/services/Laser-Cutting" className={styles.link}>
                Laser Cutting
              </Link>
              <Link to="/services/PCB-Manufacturing" className={styles.link}>
                PCB Manufacturing
              </Link>
              <Link to="/services/Silicon-Molding" className={styles.link}>
                Silicon Molding
              </Link>
              <Link to="/services/Product-Development" className={styles.link}>
                Product Development
              </Link>
            </div>
          </Col>
          <Col
            md={4}
            className="d-flex justify-content-start align-items-md-start align-items-center flex-column py-md-0 py-4"
          >
            {" "}
            <span
              className={`${styles.heading} d-block text-white fw-bold pb-3`}
            >
              Get in Touch
            </span>
            <span
              className={`span d-block fw-light text-white d-flex align-items-center ${styles.link}`}
            >
              <AiOutlineMail className="me-2" /> Email :
            </span>
            <span
              className={`span d-block fw-light text-white d-flex align-items-center ${styles.link}`}
            >
              technowrenltd@gmail.com
            </span>
          </Col>
          <Col
            md={4}
            className="d-flex justify-content-start align-items-md-end align-items-center flex-column"
          >
            {" "}
            <span
              className={`${styles.heading} d-block text-white fw-bold pb-2`}
            >
              Follow Us
            </span>
            <div className={styles.line}></div>
            <div className={styles.social}>
              <a href="#" className={styles.icon}>
                <AiOutlineFacebook />
              </a>
              <a href="#" className={styles.icon}>
                <AiOutlineLinkedin />
              </a>
              <a href="#" className={styles.icon}>
                <AiOutlineTwitter />
              </a>
              <a href="#" className={styles.icon}>
                <AiOutlineYoutube />
              </a>
            </div>
            <div className="d-flex justify-content-start align-items-md-end align-items-center flex-column">
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
